import dayjs from "dayjs";

export const DATE_PICKER_FORMAT = "DD-MM-YYYY";
export const DATE_TIME_PICKER_FORMAT = `${DATE_PICKER_FORMAT} HH:mm`;

/** Aligns with MUI X default min; explicit so wrappers override provider defaults consistently. */
export const DATE_PICKER_MIN_CALENDAR_DATE = dayjs("1900-01-01");

/**
 * MUI X defaults maxDate to 2099-12-31, which rejects long-term contract dates (e.g. 2100+).
 */
export const DATE_PICKER_MAX_CALENDAR_DATE = dayjs("2200-12-31");
